<template>
  <div class="drawer-con" style="font-size: 20px;">
    <div :class="'drawer-box'" @click="open" v-show="!drawer"></div>
    <el-drawer
      title=""
      :visible.sync="drawer"
      :modal="false"
      :direction="'ltr'"
      :with-header="false"
    >
      <div class="drawer-con-detail" @scroll.stop="sss">
        <div class="drawer-con-title">
          <a href="https://www.legalxchain.com" target="_blank"
            ><img
              src="../../assets/images/drawer/legalxchain_ch_logo.png"
              alt=""
          /></a>
        </div>
        <div class="drawer-con-detail-con">
          <!-- 真相科技产品分类 -->
          <div
            :class="['drawer-con-detail-item', `drawer-title`]"
            v-for="(item, index) in dataLink.filter(
              (item) => item.category == 1
            )"
            v-if="item.display == 1 && item.dapp_name != 'legalXchain浏览器'"
            :key="item.dapp_name"
          >
            <p class="drawer-con-detail-item-title">
              <i class="bcz"></i><span>{{ item.dapp_name }}</span>
            </p>
            <div :class="['drawer-con-detail-item-con', `drawer-con`]">
              <div class="drawer-con-detail-item-con-log">
                <img
                  :src="item.menu_logo"
                  :style="{ width: item.width ? item.width + 'px' : 'auto' }"
                  alt=""
                />
              </div>
              <p class="drawer-con-detail-item-con-desc">
                {{ item.description }}
              </p>
              <a class="nextTo" target="_blank" :href="item.dapp_home_url"
                >快速进入</a
              >
            </div>
          </div>
          <span
            :class="'drawer-con-detail-item-line'"
            :style="{ 'border-bottom': '1px dotted rgba(255,255,255,0.2)' }"
          >
          </span>
          <!-- 电子证据平台（Dapp系统） -->
          <div
            :class="['drawer-con-detail-item', `drawer-title`]"
            v-for="(item, index) in dataLink.filter(
              (item) => item.category == 2
            )"
            v-if="item.display == 1 && item.dapp_name != 'legalXchain浏览器'"
            :key="item.dapp_name"
          >
            <p class="drawer-con-detail-item-title">
              <i class="bcz"></i><span>{{ item.dapp_name }}</span>
            </p>
            <div :class="['drawer-con-detail-item-con', `drawer-con`]">
              <div class="drawer-con-detail-item-con-log">
                <img
                  :src="item.menu_logo"
                  :style="{ width: item.width ? item.width + 'px' : 'auto' }"
                  alt=""
                />
              </div>
              <p class="drawer-con-detail-item-con-desc">
                {{ item.description }}
              </p>
              <a class="nextTo" target="_blank" :href="item.dapp_home_url"
                >快速进入</a
              >
            </div>
          </div>
          <span :class="'drawer-con-detail-item-line'" :style="{'border-bottom':'1px dotted rgba(255,255,255,0.2)'}">
          </span>
            <!--（Dapp-APP） -->
          <div :class="['drawer-con-detail-item', `drawer-title`]" v-for="(item,index) in dataLink.filter(item=>item.category==4)" v-if="item.display==1 && item.dapp_name !='legalXchain浏览器'" :key="item.dapp_name">
              <p class="drawer-con-detail-item-title"><i class="bcz"></i><span>{{item.dapp_name}}</span></p>
              <div :class="['drawer-con-detail-item-con', `drawer-con`]">
                  <!-- app下载 -->
                  <div class="drawer-con-detail-item-app">
                    <div class="drawer-con-detail-item-app-item">
                        <img :src="item.menu_logo"/>
                        <span>{{ item.dapp_name.split('-')[1].slice(0,item.dapp_name.split('-')[1].indexOf('APP') !=-1?item.dapp_name.split('-')[1].indexOf('APP'):item.dapp_name.split('-')[1].length) }}</span>
                        <p> {{item.description}}</p>
                    </div>
                  </div>
              </div>
          </div>
          <span
            :class="'drawer-con-detail-item-line'"
            :style="{ 'border-bottom': '1px solid rgba(255,255,255,0.2)' }"
          >
          </span>
          <!-- 电子诉讼平台（互联网法院） -->
          <div
            :class="['drawer-con-detail-item', `drawer-title`]"
            v-for="(item, index) in dataLink.filter(
              (item) => item.category == 3
            )"
            v-if="item.display == 1 && item.dapp_name != 'legalXchain浏览器'"
            :key="item.dapp_name"
          >
            <p class="drawer-con-detail-item-title">
              <i class="bcz"></i><span>{{ item.dapp_name }}</span>
            </p>
            <div :class="['drawer-con-detail-item-con', `drawer-con`]">
              <div class="drawer-con-detail-item-con-log">
                <img :src="item.menu_logo" :style="{ width: '200px' }" alt="" />
              </div>
              <p class="drawer-con-detail-item-con-desc">
                {{ item.description }}
              </p>
              <a class="nextTo" target="_blank" :href="item.dapp_home_url"
                >快速进入</a
              >
            </div>
          </div>
          <!-- 其他分类 -->
          <template
            v-if="
              dataLink.filter(
                (item) =>
                  item.category != 3 && item.category !=4&& item.category != 2 && item.category != 1
              ).length
            "
          >
            <span
              :class="'drawer-con-detail-item-line'"
              :style="{ 'border-bottom': '1px solid rgba(255,255,255,0.2)' }"
            >
            </span>
            <div
              :class="['drawer-con-detail-item', `drawer-title`]"
              v-for="(item, index) in dataLink.filter(
                (item) =>
                  item.category != 3 && item.category != 2 && item.category != 1
              )"
              v-if="item.display == 1"
              :key="item.dapp_name"
            >
              <p class="drawer-con-detail-item-title">
                <i class="bcz"></i><span>{{ item.dapp_name }}</span>
              </p>
              <div :class="['drawer-con-detail-item-con', `drawer-con`]">
                <div class="drawer-con-detail-item-con-log">
                  <img
                    :src="item.menu_logo"
                    :style="{ width: item.width ? item.width + 'px' : 'auto' }"
                    alt=""
                  />
                </div>
                <p class="drawer-con-detail-item-con-desc">
                  {{ item.description }}
                </p>
                <a class="nextTo" target="_blank" :href="item.dapp_home_url"
                  >快速进入</a
                >
              </div>
            </div>
          </template>
        </div>
        <!-- <div class="drawer-con-title">
                    <a href="https://www.legalxchain.com" target="_blank"><img src="../../assets/images/drawer/legalxchain_ch_logo.png" alt=""/></a>
                </div>
                <div class="drawer-con-detail-con">
                    <div :class="['drawer-con-detail-item', `drawer${item.index}-title`]" v-for="(item,index) in dataLink" :key="index">
                        <p class="drawer-con-detail-item-title"><i class="bcz"></i><span>{{item.title}}</span></p>
                        <div :class="['drawer-con-detail-item-con', `drawer${item.index}-con`]">
                            <div class="drawer-con-detail-item-con-log">
                                <img :src="require('../../assets/images/drawer/'+item.img)" :style="{'width':item.width?item.width+'px':'auto'}" alt=""/>
                            </div>
                            <p class="drawer-con-detail-item-con-desc">
                                {{item.desc}}
                            </p>
                            <a class="nextTo" target="_blank" :href="item.linkTo">快速进入</a>
                        </div>
                        <span v-show="item.line" :class="[item.line?'drawer-con-detail-item-line':'']" :style="{'border-top':item.dashed?item.dashed:'1px solid rgba(255,255,255,0.2)','width':item.borderW?item.borderW:'225px','margin-left':item.borderW?'0px':'-10px'}">
                        </span>
                    </div>
                </div> -->
      </div>
      <div :class="'open'" v-show="drawer" @click="open"></div>
    </el-drawer>
  </div>
</template>
<script>
import axios from "axios";
import BaseApi from "@lib/baseApi.js";
export default {
  props: ["opens"],
  data() {
    return {
      drawer: false,
      publicPath: process.env.BASE_URL,
      dataLink: [],
    };
  },
  created() {
    this.getUrlList();
  },
  methods: {
    open() {
      this.drawer = !this.drawer;
    },
    sss() {},
    getUrlList() {
      BaseApi.createRpcToken("/dapp/v2/getDappList")
      .then(
          data => {
              this.dataLink=data.datas.menuList;
          },
          data => {
              // console.log(data);
          }
      )
      .catch(function(e) {
          errorLog(e);
      });
},
  },
  mounted() {
    this.drawer = this.opens;
  },
};
</script>
<style scoped lang="scss">
.drawer-con {
  width: 300px;
  position: relative;
  .drawer-box {
    width: 14px;
    height: 60px;
    background: url("../../assets/images/drawer/fold_icon.png") no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: fixed;
    top: 50%;
    margin-top: -30px;
    left: 0px;
    transition: 0.5s;
    z-index: 9999999999;
    box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    // filter: grayscale(100%);
    // -webkit-filter: grayscale(100%);
    // -moz-filter: grayscale(100%);
    // -ms-filter: grayscale(100%);
    // -o-filter: grayscale(100%);
    // -webkit-filter: grayscale(1);
    // filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    // filter: gray;
  }
  .open {
    width: 14px;
    height: 60px;
    background: url("../../assets/images/drawer/Unfold_icon.png") no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: absolute;
    top: 50%;
    transition: 0.5s;
    margin-top: -30px;
    right: -14px;
    z-index: 9999999999;
    cursor: pointer;
    box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.1);
    // filter: grayscale(100%);
    // -webkit-filter: grayscale(100%);
    // -moz-filter: grayscale(100%);
    // -ms-filter: grayscale(100%);
    // -o-filter: grayscale(100%);
    // -webkit-filter: grayscale(1);
    // filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    // filter: gray;
  }
  /deep/.el-drawer__wrapper {
    z-index: 999999999 !important;
  }
  /deep/.el-drawer {
    width: 254px !important;
    position: relative;
    overflow: visible;
    background-color: rgba(0, 0, 0, 0.8) !important;
    // box-shadow: none !important;
  }
  .drawer-con-detail {
    width: 100%;
    text-align: center;
    height: 730px;
    overflow-y: auto;
    // filter: grayscale(100%);
    // -webkit-filter: grayscale(100%);
    // -moz-filter: grayscale(100%);
    // -ms-filter: grayscale(100%);
    // -o-filter: grayscale(100%);
    // -webkit-filter: grayscale(1);
    // filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    // filter: gray;
    .drawer-con-title {
      box-sizing: border-box;
      padding-top: 18px;
      border-bottom: 1px dotted rgba(255, 255, 255, 0.1);
      width: 225px;
      height: 140px;
      margin-left: 10px;
      text-align: center;
      a:-webkit-any-link:focus-visible {
        outline-offset: 1px;
      }
      a {
        outline: none;
      }
      img {
        width: 166px;
        height: auto;
        display: inline-block;
        margin: 0 auto;
        margin-left: 10px;
      }
    }
    .drawer-con-detail-con {
      width: 100%;
      height: 578px;
      overflow-y: auto;
      padding-top: 4px;
      box-sizing: border-box;
      scrollbar-width: none;
      .drawer-con-detail-item {
        width: 100%;
        .drawer-con-detail-item-title {
          width: 100%;
          height: 30px;
          cursor: pointer;
          line-height: 30px;
          text-align: left;
          padding-left: 10px;
          box-sizing: border-box;
          display: flex;
          i{
              display: inline-block;
              width:8px;
              height:8px;
              background:rgba(255,255,255,1);
              opacity:0.6;
              border-radius: 8px;
              margin-right: 11px;
              flex-shrink: 0;
          }
          span{
              font-size:12px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(255,255,255,1);
              line-height:12px;
              opacity: 0.7;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
          }
        }
        .drawer-con-detail-item-con {
          width: 100%;
          box-sizing: border-box;
          max-height: 0px;
          overflow: hidden;
          transition: max-height 1s;
          background: rgba(255, 255, 255, 0.07);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .drawer-con-detail-item-con-log {
            margin-bottom: 20px;
            margin-top: 20px;
            text-align: center;
            img {
              display: inline-block;
              width: auto;
            }
          }
          .drawer-con-detail-item-con-desc {
            width: 204px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 18px;
            margin: 0 auto;
            opacity: 0.7;
            text-align: left;
          }
          .nextTo {
            width: 204px;
            height: 32px;
            background: #c62e3f;
            border-radius: 4px;
            display: inline-block;
            margin-top: 20px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            line-height: 32px;
            margin-bottom: 20px;
          }
          .nextTo:hover {
            background: #b41d2f;
          }
          .drawer-con-detail-item-app{
              width: 100%;
              min-height: 141px;
              box-sizing: border-box;
              padding: 16px 0px;
              display: flex;
              justify-content: center;
              img{
                  width: 57px;
                  height: 57px;
                  margin: 0 auto;
                  margin-bottom: 4px;
                  display: block;
              }
              span{
                  font-size: 12px;
                  color: #C8C8C8;
              }
              p{
                  padding: 10px 16px;
                  box-sizing: border-box;
                  color: #C8C8C8;
                  font-size: 12px;
                  font-weight: 400;
                  color: #C8C8C8;
                  line-height: 18px;
                  text-align: left;
              }
          }
        }
      }
      .drawer-con-detail-item-line {
        box-sizing: border-box;
        margin: 10px 0px;
        margin-left: -10px;
        // border-bottom: 1px solid rgba(255,255,255,0.2);
        display: inline-block;
        width: 225px;
        height: 1px;
      }

      .drawer-title:hover .drawer-con{
          max-height: 800px;
      }
      .drawer-title:hover .drawer-con-detail-item-title i{
          background:#D96E6D;
      }
      .drawer-title:hover .drawer-con-detail-item-title span{
          color: #D96E6D;
      }
    }
  }
  .drawer-con-detail-con::-webkit-scrollbar {
    opacity: 0 !important;
    width: 0px !important;
  }
}
@media screen and (min-height: 900px) and (min-width: 1900px) {
  .drawer-con .drawer-con-detail .drawer-con-detail-con {
    height: 795px;
    overflow-y: auto;
    width: 100%;
  }
  .drawer-con-detail-con::-webkit-scrollbar {
    opacity: 0 !important;
    width: 0.5px !important;
  }
  .drawer-con .drawer-con-detail {
    width: 100%;
    text-align: center;
    height: 936px;
    overflow-y: auto;
  }
}
//苹果pc
@media screen and (min-height: 955px) and (max-width: 1900px) {
  .drawer-con .drawer-con-detail .drawer-con-detail-con {
    height: 815px;
    overflow-y: auto;
    width: 100%;
  }
  .drawer-con-detail-con::-webkit-scrollbar {
    opacity: 0 !important;
    width: 0.5px !important;
  }
  .drawer-con .drawer-con-detail {
    width: 100%;
    text-align: center;
    height: 956px;
    overflow-y: auto;
  }
}
</style>